// src/components/store/sections/gallery/GalleryV72CarouselstripCoralFlame.tsx
"use client";

import React from "react";
import DynamicGalleryVariant from "./DynamicGalleryVariant";

export default function GalleryV72CarouselstripCoralFlame(props: any) {
  return (
    <DynamicGalleryVariant
      variantNumber={72}
      archKey="carousel_strip"
      archLabel="Marquee Strip"
      palName="CoralFlame"
      grad="from-orange-500 via-rose-500 to-pink-700"
      lightBg="bg-orange-50"
      textCol="text-orange-700"
      borderCol="border-orange-200"
      btnCls="bg-rose-600 hover:bg-rose-700"
      hexCol="#f97316"
      {...props}
    />
  );
}
